import { render, staticRenderFns } from "./StudyPlans.vue?vue&type=template&id=3dc4ed20&"
import script from "./StudyPlans.vue?vue&type=script&lang=js&"
export * from "./StudyPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports